module.exports = __webpack_public_path__ + "img/MOVE.7a2464de.svg";